import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = { class: "wrapper" };
const _hoisted_2 = { class: "page-content" };
const _hoisted_3 = { class: "container-fluid" };
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "col-12" };
const _hoisted_6 = { class: "page-title-box" };
const _hoisted_7 = { class: "mb-0 fw-semibold" };
const _hoisted_8 = { class: "breadcrumb mb-0" };
const _hoisted_9 = ["href"];
const _hoisted_10 = { class: "footer" };
const _hoisted_11 = { class: "container-fluid" };
const _hoisted_12 = { class: "row" };
const _hoisted_13 = { class: "col-12 text-center" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AppTopbar = _resolveComponent("AppTopbar");
    const _component_ThemeSettings = _resolveComponent("ThemeSettings");
    const _component_AppSidebar = _resolveComponent("AppSidebar");
    const _component_IconifyIcon = _resolveComponent("IconifyIcon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_AppTopbar, { onToggleSidebar: $setup.handleSidebarToggle }, null, 8, ["onToggleSidebar"]),
        _createElementVNode("div", null, [
            _createVNode(_component_ThemeSettings)
        ]),
        _createVNode(_component_AppSidebar),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("h4", _hoisted_7, _toDisplayString($props.pageTitle), 1),
                            _createElementVNode("ol", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.breadcrumbs, (crumb, index) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        key: index,
                                        class: _normalizeClass(['breadcrumb-item', { 'active': crumb.active }])
                                    }, [
                                        (!crumb.active)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                href: crumb.path || 'javascript: void(0);'
                                            }, _toDisplayString(crumb.label), 9, _hoisted_9))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createTextVNode(_toDisplayString(crumb.label), 1)
                                            ], 64))
                                    ], 2));
                                }), 128))
                            ])
                        ])
                    ])
                ]),
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ]),
            _createElementVNode("footer", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                            _createTextVNode(_toDisplayString($setup.currentYear) + " © پلّه. طراحی شده توسط ", 1),
                            _createVNode(_component_IconifyIcon, {
                                class: "fs-18 align-middle text-danger",
                                icon: "solar:hearts-bold-duotone"
                            }),
                            _cache[0] || (_cache[0] = _createElementVNode("a", {
                                class: "fw-bold footer-text",
                                href: "#",
                                target: "_blank"
                            }, "خانه خلاقیت دو نقطه", -1))
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
